import r from "./index652.js";
import { overlayEmits as t, overlayProps as m } from "./index652.js";
const e = r;
export {
  e as ElOverlay,
  e as default,
  t as overlayEmits,
  m as overlayProps
};
